import React from "react"
import { connect } from "react-redux"
import { updatePersonalDetails } from "../../redux/homePage/homePage.actions"
import TeacherFormContainer from "../Container/TeacherFormContainer"
import SuperForm from "./SuperForm"
import { API } from "../../API"

class SuperDetails extends React.Component {
  state = {
    fund_type: "",
    fund_name: "",
    usi: "",
    fund_abn: "",
    member_number: "",
    fund_name2: "",
    fund_abn2: "",
    member_number2: "",
    fund_bsb: "",
    fund_bank_acc_no: "",
  }

  // disabling this for now
  // componentDidMount() {
  //   if (!this.props.user.bank_details_enabled) {
  //     notify.show("This page is not enabled for you yet.");
  //     this.props.history.push("/Home2");
  //   }
  // }

  componentDidMount() {
    API.getUserSensitiveData()
      .then(res => {
        // console.log(res.data)
        // this.setState(res.data)
        const { fund_type, fund_name, usi, fund_abn, member_number, fund_name2, fund_abn2, member_number2, fund_bsb, fund_bank_acc_no } = res.data.user;
        this.setState({ fund_type, fund_name, usi, fund_abn, member_number, fund_name2, fund_abn2, member_number2, fund_bsb, fund_bank_acc_no });
      })
      .catch(err => {
        console.log(err)
      })
  }

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

  handleSuperTypeChange = (e) => {
    this.setState({ fund_type: e.target.id })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const fields = [
      "regulated",
      "self-managed",
      "default",
      "stapled",
      "fund_name",
      "usi",
      "fund_abn",
      "member_number",
      "fund_name2",
      "fund_abn2",
      "fund_bank_acc_no",
      "member_number2",
      "fund_bsb",
      "authorize",
    ]
    let errors = false

    for (let field of fields) {
      const input = document.getElementById(field)
      if (!input.reportValidity()) {
        errors = true
        break
      }
    }

    if (!errors) {
      this.props.updatePersonalDetails({ ...this.state })
    }
  }

  tabs = [
    {
      pathname: "/BankDetails",
      text: "Bank Details",
    },
    {
      pathname: "/Tax",
      text: "Tax Declaration",
    },
    {
      pathname: "/Superannuation",
      text: "Superannuation",
      active: true,
    },
  ]

  render() {
    return (
      <div>
        <TeacherFormContainer
          header="Payments"
          tabs={this.tabs}
          handleSubmit={this.handleSubmit}
        >
          <SuperForm
            handleFormFieldChange={this.handleFormFieldChange}
            handleSuperTypeChange={this.handleSuperTypeChange}
            state={this.state}
            user = {this.props.user}
          />
        </TeacherFormContainer>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return { user: state.user.user }
}

const mapDispatchToProps = (dispatch) => ({
  updatePersonalDetails: (details) => dispatch(updatePersonalDetails(details)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SuperDetails)
